import ProMessages from './ProMessages';

export default ProMessages;
